var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-pilot-list"},[_c('div',[(_vm.dataReady)?[_c('pilot-listing',{ref:"pilotListing",attrs:{"pilotsData":_vm.pilots}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }